module.exports = __webpack_public_path__ + "media/demo.bc0a35b1.mp4";